// @LTG-ID: F-021
// @STATUS: BUILT
// @HERMETIC: false  // consumes ExternalCTA + cta-strip-order cta-id
// @DOCS: 08_FEATURES.md#F-021, source Landing Page.html lines 2978-3019
// @CHANGED: 2026-02 session_003 (CHG-0050)
// @OWNER: web
//
// F-021 — Final navy "close" section before Footer. Split layout: left = copy
// (eyebrow + h2 + lede + microtrust dots), right = white pricing card (price +
// bullet list + primary CTA + 2 fineprint paragraphs). Section id="enroll" per
// source. The source's bare `<a href="https://app.letstalkgrowth.com" target="_blank">`
// is replaced here with `<ExternalCTA ctaId="cta-strip-order">` per ADR-008
// (the cta-id is pre-reserved in `lib/cta-ids.js` line 85, path
// `/order/snapshot?via=cta-strip`).

import ExternalCTA from "../../lib/external-cta";
import ItalicPeriod from "../brand/ItalicPeriod";
import "./cta-strip.css";

export function CtaStrip() {
    return (
        <section
            className="ltg-cta-strip-section"
            id="enroll"
            data-testid="cta-strip-section"
        >
            <div className="ltg-cta-strip" data-testid="cta-strip-wrap">
                <div className="ltg-cta-strip-inner">
                    <div className="ltg-cta-strip__copy">
                        <span
                            className="ltg-eyebrow ltg-cta-strip__eyebrow"
                            data-testid="cta-strip-eyebrow"
                        >
                            Ready when you are
                        </span>
                        <h2
                            className="ltg-cta-strip__h2"
                            data-testid="cta-strip-h2"
                        >
                            The Strategic Snapshot
                            <ItalicPeriod />
                            <br />
                            $995 &middot; KGOB methodology &middot; CPA-signed.
                        </h2>
                        <p className="ltg-cta-strip__lede">
                            No discovery call. No proposal cycle. No surprises
                            in the invoice. Pay $995, answer a short intake,
                            and we get to work. The Strategic Snapshot is an
                            indicative valuation, not a formal appraisal under
                            SSVS No.&nbsp;1.
                        </p>
                        <div
                            className="ltg-cta-microtrust"
                            data-testid="cta-strip-microtrust"
                        >
                            <span>· CPA-signed PDF</span>
                            <span>· One round of Q&amp;A included</span>
                            <span>· Yours to keep, share, and refer to</span>
                        </div>
                    </div>

                    <div className="ltg-cta-card" data-testid="cta-strip-card">
                        <div className="ltg-cta-card__price">
                            <span
                                className="ltg-cta-card__num"
                                data-testid="cta-strip-price"
                            >
                                $995
                            </span>
                            <span className="ltg-cta-card__sub">
                                one-time
                            </span>
                        </div>
                        <ul
                            className="ltg-cta-card__list"
                            data-testid="cta-strip-bullets"
                        >
                            <li>Complete report, your business</li>
                            <li>Valuation range, methodology shown</li>
                            <li>10-lever scorecard vs. peers</li>
                            <li>3 priority moves, ranked</li>
                            <li>Q&amp;A with Sara, written</li>
                        </ul>
                        <ExternalCTA
                            ctaId="cta-strip-order"
                            className="ltg-btn ltg-btn-teal ltg-cta-card__btn"
                            data-testid="cta-strip-primary"
                        >
                            Begin enrollment{" "}
                            <span
                                className="ltg-arrow"
                                aria-hidden="true"
                            >
                                →
                            </span>
                        </ExternalCTA>
                        <p className="ltg-cta-card__fineprint">
                            Secure checkout &middot; indicative valuation
                        </p>
                        <p className="ltg-cta-card__fineprint ltg-cta-card__fineprint--italic">
                            Indicative valuation. Not a formal appraisal under
                            AICPA SSVS No.&nbsp;1.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CtaStrip;
